import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "directions-companies" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_5 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_6 = { class: "flex items-center justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_directions_actions = _resolveComponent("company-directions-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_company_directions_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createCompanyDirection,
          onUpdate: _ctx.updateCompanyDirection,
          onDelete: _ctx.deleteCompanyDirection
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Направления компании" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.startCreate
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" Добавить направление ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("form", {
        class: "mt-6 bg-white border px-6 py-4",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onApplyFilters && _ctx.onApplyFilters(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_the_select, {
            value: _ctx.filters_state.companyId,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
            placeholder: "Компания",
            "search-without-refresh": "",
            "error-text": "При получении списка компаний произошла ошибка",
            "select-by": "id",
            disabled: _ctx.state.is_loading,
            loading: _ctx.data_state.companies.is_loading,
            options: _ctx.data_state.companies.list,
            failed: _ctx.data_state.companies.is_failed,
            onRefresh: _ctx.loadCompanies
          }, null, 8, ["value", "disabled", "loading", "options", "failed", "onRefresh"]),
          _createVNode(_component_the_select, {
            value: _ctx.filters_state.directionId,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.directionId) = $event)),
            placeholder: "Направление",
            "search-without-refresh": "",
            "error-text": "При получении списка направлений произошла ошибка",
            "select-by": "id",
            "search-by": "fromCityName",
            disabled: _ctx.state.is_loading,
            loading: _ctx.data_state.directions.is_loading,
            options: _ctx.data_state.directions.list,
            failed: _ctx.data_state.directions.is_failed,
            onRefresh: _ctx.loadDirections
          }, {
            "selected-option": _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.fromCityName) + " - " + _toDisplayString(option.whereCityName), 1)
            ]),
            option: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.fromCityName) + " - " + _toDisplayString(option.whereCityName), 1)
            ]),
            _: 1
          }, 8, ["value", "disabled", "loading", "options", "failed", "onRefresh"]),
          _createVNode(_component_the_select, {
            value: _ctx.filters_state.isActive,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.isActive) = $event)),
            placeholder: "Статус",
            "search-without-refresh": "",
            "select-by": "value",
            searchable: false,
            disabled: _ctx.state.is_loading,
            options: _ctx.IS_ACTIVE_OPTIONS
          }, null, 8, ["value", "disabled", "options"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_the_button, {
            class: "second text small mr-2",
            loading: _ctx.state.is_loading,
            onClick: _ctx.onResetFilters
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Сброс ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка направлений произошла ошибка",
              "error-message": _ctx.state.failure.error_state.message,
              "error-url": _ctx.state.failure.error_state.url,
              "error-status": _ctx.state.failure.error_state.status,
              onRefresh: _ctx.loadCompanyDirections
            }, null, 8, ["loading", "error-message", "error-url", "error-status", "onRefresh"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.DirectionsCompaniesColumns,
                  rows: _ctx.state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.state.pagination.total_items,
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadCompanyDirections,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'company')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "text-blue-500 text-center",
                          to: `/companies/${row.companyId}`,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.company), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (column.key === 'isActive')
                        ? (_openBlock(), _createBlock(_component_cheap, {
                            key: 1,
                            class: _normalizeClass(["small w-min", { green: row.isActive, red: !row.isActive }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.isActive ? 'Активно' : 'Не активно'), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                          ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createVNode(_component_the_button, {
                      hint: "Редактировать",
                      class: "primary extra-small",
                      onClick: ($event: any) => (_ctx.startUpdate(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_the_button, {
                      hint: "Удалить",
                      class: "red extra-small ml-2",
                      onClick: ($event: any) => (_ctx.startDelete(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}